import axios from 'axios';
import configureStore from './store'
import { isAuthenticated } from './auth'
import { isClient } from './utils'
import { BrowserRouter } from 'react-router-dom';


let SERVER_URL;
if (isClient() && window.location.hostname == 'localhost') {
    SERVER_URL = 'http://localhost:3000/';
} else {
    //SERVER_URL = 'http://149.28.168.92/';
    SERVER_URL = 'https://storedesign.aesop.com/';
}


export function fetchData(endpoint) {    

    let config = {}

    if (isClient()) {
        const jwt = localStorage.getItem('jwtToken');

        if (jwt) {
            config = {
                headers: {
                    'Authorization': `Bearer ${jwt}`,
                    'Accept': 'application/json'
                }
            }
        }
    }

    return new Promise((resolve, reject) => {
        axios.get(SERVER_URL + endpoint, config)
            .then((response) => {
                if (response.data) {
                    resolve(response.data);
                }
            })
            .catch(error =>  {
                reject(error)
            })      
    
    })
}


export function postData(endpoint, data) {

    // console.log(SERVER_URL, endpoint, data)

    let config = {}

    if (isClient()) {
        const jwt = localStorage.getItem('jwtToken');

        if (jwt) {
            config = {
                headers: {
                    'Authorization': `Bearer ${jwt}`,
                    'Accept': 'application/json'
                }
            }      
        }
    }

    return new Promise((resolve, reject) => {

       // console.log('config',config);

        axios.post(SERVER_URL + endpoint, data, config)
            .then((response) => {
                //console.log('postData resp',response)
                if (response.data) {
                    resolve(response.data);
                }
            })
            .catch(error =>  {
                reject(error)
            })   
    })
}


export function checkToken() {    

    let config = {}

    if (isClient()) {
        const jwt = localStorage.getItem('jwtToken');

        if (jwt) {
            config = {
                headers: {
                    'Authorization': `Bearer ${jwt}`,
                    'Accept': 'application/json'
                }
            }
        }
    }
        
    return new Promise((resolve, reject) => {
        axios.post(SERVER_URL + 'wpapi/checkToken', {}, config)
            .then((response) => {
                if (response.data) {
                    resolve(response.data);
                }
            })
            .catch(error =>  {
                reject(error)
            })      
    
    })
}


// WEBPACK FOOTER //
// ./client/api.js